// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2760%27 height=%2760%27 viewBox=%270 0 60 60%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg fill=%27none%27 fill-rule=%27evenodd%27%3E%3Cg fill=%27%23ffffff%27 fill-opacity=%270.1%27%3E%3Ccircle cx=%2730%27 cy=%2730%27 r=%272%27/%3E%3C/g%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --hot-gradient: linear-gradient(135deg, #ff6b6b 0%, #ff8e8e 100%);
  --warm-gradient: linear-gradient(135deg, #ffd166 0%, #ffe066 100%);
  --cold-gradient: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  --total-gradient: linear-gradient(135deg, #8e2de2 0%, #4a00e0 100%);
  --primary-gradient: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  --secondary-gradient: linear-gradient(135deg, #f857a6 0%, #ff5858 100%);
  --success-gradient: linear-gradient(135deg, #00b09b 0%, #96c93d 100%);
  --header-gradient: linear-gradient(135deg, #4776e6 0%, #8e54e9 100%);
  --card-gradient: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.08);
  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 8px 30px rgba(0, 0, 0, 0.12);
  --border-radius-sm: 8px;
  --border-radius-md: 12px;
  --border-radius-lg: 20px;
  --border-radius-xl: 30px;
  --transition-fast: 0.2s ease;
  --transition-normal: 0.3s ease;
  --transition-slow: 0.5s ease;
  --font-primary: "Poppins", "Inter", -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, sans-serif;
  --color-text-primary: #1e293b;
  --color-text-secondary: #64748b;
  --color-text-tertiary: #94a3b8;
  --color-bg-primary: #ffffff;
  --color-bg-secondary: #f8fafc;
  --color-bg-tertiary: #f1f5f9;
  --color-border: #e2e8f0;
  --color-hot: #ff6b6b;
  --color-warm: #ffd166;
  --color-cold: #4facfe;
  --color-active: #48bb78;
  --color-pending: #ed8936;
  --color-inactive: #a0aec0;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: var(--font-primary);
  background: var(--color-bg-secondary);
  color: var(--color-text-primary);
  line-height: 1.6;
}

/* Page Header */
.Attendence-page-header {
  background: var(--header-gradient);
  padding: 2rem 1.5rem;
  text-align: center;
  color: white;
  margin-bottom: 2rem;
  position: relative;
  overflow: hidden;
}

.Attendence-page-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    repeat;
  animation: float 20s ease-in-out infinite;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

.Attendence-page-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;
}

.Attendence-page-subtitle {
  font-size: 1.1rem;
  opacity: 0.9;
  font-weight: 400;
  position: relative;
  z-index: 1;
}

/* Main Container */
.Attendence-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 1.5rem 2rem;
}
.Attendence-header-container {
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-lg);
  padding: 1rem;
  margin-bottom: 2rem;
  box-shadow: var(--shadow-md);
  position: relative;
  overflow: hidden;
}

.Attendence-header-content {
  text-align: center;
  margin-bottom: 2rem;
}

.Attendence-header {
  font-size: 2rem;
  font-weight: 600;
  color: #000000;
  margin: 0 0 1rem 0;
  /* background: var(--primary-gradient); */
  /* -webkit-background-clip: text; */
  /* -webkit-text-fill-color: transparent; */
  /* background-clip: text; */
}

.Attendence-header-decoration {
  width: 80px;
  height: 4px;
  background: var(--primary-gradient);
  margin: 0 auto;
  border-radius: 2px;
}

/* Controls */
.Attendence-controls {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 1.5rem;
  align-items: end;
}

.Attendence-form-group {
  display: flex;
  flex-direction: column;
}

.Attendence-label {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: var(--color-text-primary);
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
}

.Attendence-label-icon {
  margin-right: 0.5rem;
  font-size: 1.1rem;
}

.Attendence-select-wrapper {
  position: relative;
}

.Attendence-select,
.Attendence-date-input {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-md);
  font-size: 1rem;
  font-family: var(--font-primary);
  background: var(--color-bg-primary);
  color: var(--color-text-primary);
  transition: var(--transition-normal);
}

.Attendence-select:focus,
.Attendence-date-input:focus {
  outline: none;
  border-color: #6a11cb;
  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);
  transform: translateY(-1px);
}

.Attendence-select {
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: right 0.75rem center;
  background-repeat: no-repeat;
  background-size: 1rem;
  padding-right: 2.5rem;
}

/* Buttons */
.Attendence-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: var(--border-radius-md);
  font-size: 1rem;
  font-weight: 600;
  font-family: var(--font-primary);
  cursor: pointer;
  transition: var(--transition-normal);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: relative;
  overflow: hidden;
}

.Attendence-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s;
}

.Attendence-button:hover::before {
  left: 100%;
}

.Attendence-button-load {
  background: linear-gradient(135deg, #0d5787 0%, #91c8e4 100%);
  color: white;
  box-shadow: var(--shadow-sm);
}

.Attendence-button-load:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.Attendence-button-submit {
  /* background: var(--success-gradient); */
  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);
  color: white;
  font-size: 1.1rem;
  padding: 1rem 2rem;
  box-shadow: var(--shadow-sm);
}

.Attendence-button-submit:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.Attendence-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.Attendence-button-icon {
  font-size: 1.1rem;
}

/* Loading States */
.Attendence-loading {
  pointer-events: none;
}

.Attendence-spinner {
  width: 1rem;
  height: 1rem;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Error Message */
.Attendence-error-message {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: var(--hot-gradient);
  color: white;
  padding: 1rem 1.25rem;
  border-radius: var(--border-radius-md);
  margin-bottom: 1.5rem;
  font-weight: 500;
  box-shadow: var(--shadow-sm);
  animation: slideIn 0.3s ease;
}

.Attendence-error-icon {
  font-size: 1.2rem;
}

.Attendence-error-text {
  flex: 1 1;
}

.Attendence-error-close {
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity var(--transition-fast);
}

.Attendence-error-close:hover {
  opacity: 1;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Success Message */
.Attendence-success-message {
  position: fixed;
  top: 2rem;
  right: 2rem;
  background: var(--success-gradient);
  color: white;
  padding: 1rem 1.5rem;
  border-radius: var(--border-radius-md);
  font-weight: 600;
  box-shadow: var(--shadow-lg);
  z-index: 1000;
  animation: slideInRight 0.3s ease;
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Table Wrapper */
.Attendence-table-wrapper {
  /* background: var(--color-bg-primary);
  border-radius: var(--border-radius-lg);
  padding: 2rem;
  box-shadow: var(--shadow-md); */
  animation: fadeInUp 0.5s ease;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Summary Cards */
.Attendence-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.Attendence-summary-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  border-radius: var(--border-radius-lg);
  color: white;
  font-weight: 600;
  overflow: hidden;
  transition: transform var(--transition-normal);
  box-shadow: var(--shadow-sm);
  width: 250px;
}

.Attendence-summary-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-md);
}

.Attendence-summary-card.Attendence-present {
  background: var(--success-gradient);
}

.Attendence-summary-card.Attendence-absent {
  background: var(--hot-gradient);
}

.Attendence-summary-card.Attendence-half-day {
  background: var(--warm-gradient);
}

.Attendence-icon {
  font-size: 2rem;
  opacity: 0.9;
}

.Attendence-info {
  flex: 1 1;
}

.Attendence-info h4 {
  margin: 0 0 0.25rem 0;
  font-size: 0.9rem;
  opacity: 0.9;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.Attendence-info p {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
}

.Attendence-card-percentage {
  font-size: 0.9rem;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.2);
  padding: 0.25rem 0.5rem;
  border-radius: var(--border-radius-sm);
}

.Attendence-card-bg {
  position: absolute;
  top: -50%;
  right: -20px;
  width: 100px;
  height: 100px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  pointer-events: none;
}

/* Table Container */
.Attendence-table-container {
  overflow-x: auto;
  border-radius: var(--border-radius-md);
  box-shadow: var(--shadow-sm);
  margin-bottom: 2rem;
}

/* Table */
.Attendence-table {
  width: 100%;
  border-collapse: collapse;
  background: var(--color-bg-primary);
  border-radius: var(--border-radius-md);
  overflow: hidden;
}

.Attendence-table thead {
  /* background: var(--header-gradient); */
  color: #000000;
  background: #f3f4f6;
}

.Attendence-table th {
  padding: 1.25rem 1rem;
  text-align: left;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 0.85rem;
}

.Attendence-table td {
  padding: 1rem;
  border-bottom: 1px solid var(--color-border);
  vertical-align: middle;
}

.Attendence-table-row:hover {
  /* background: var(--color-bg-secondary);
  transform: scale(1.01);
  transition: all var(--transition-fast); */
}

.Attendence-row-even {
  /* background: var(--color-bg-tertiary); */
}

/* Employee Details */
.Attendence-employee-id {
  font-weight: 600;
  color: var(--color-text-secondary);
}

.Attendence-employee-code {
  background: var(--card-gradient);
  padding: 0.25rem 0.5rem;
  border-radius: var(--border-radius-sm);
  font-family: "Courier New", monospace;
  font-weight: 600;
  color: var(--color-text-primary);
  font-size: 0.9rem;
}

.Attendence-employee-name {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.Attendence-name-avatar {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background: var(--primary-gradient);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 1rem;
}

.Attendence-name-text {
  font-weight: 600;
  color: var(--color-text-primary);
}

.Attendence-phone-number {
  font-family: "Courier New", monospace;
  color: var(--color-text-secondary);
}

.Attendence-designation-badge {
  /* background: var(--cold-gradient); */
  color: rgb(0, 0, 0);
  padding: 0.375rem 0.75rem;
  border-radius: var(--border-radius-xl);
  font-size: 0.85rem;
  font-weight: 600;
}

/* Status Elements */
.Attendence-status-wrapper {
  min-width: 140px;
}

.Attendence-status-select {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-sm);
  font-size: 0.9rem;
  font-family: var(--font-primary);
  cursor: pointer;
  transition: var(--transition-normal);
  background: var(--color-bg-primary);
}

.Attendence-status-select:focus {
  outline: none;
  border-color: #6a11cb;
  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);
}

.Attendence-status-badge {
  padding: 0.375rem 0.75rem;
  border-radius: var(--border-radius-xl);
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.Attendence-status-badge.Attendence-status-present {
  background: var(--success-gradient);
  color: white;
}

.Attendence-status-badge.Attendence-status-absent {
  background: var(--hot-gradient);
  color: white;
}

.Attendence-status-badge.Attendence-status-half-day {
  background: var(--warm-gradient);
  color: white;
}

/* Submit Section */
.Attendence-submit-section {
  text-align: center;
  padding-top: 1.5rem;
  border-top: 1px solid var(--color-border);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .Attendence-controls {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .Attendence-summary {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .Attendence-container {
    padding: 0 1rem 2rem;
  }

  .Attendence-page-title {
    font-size: 2rem;
  }

  .Attendence-header-container,
  .Attendence-table-wrapper {
    padding: 1.5rem;
  }

  .Attendence-table {
    font-size: 0.9rem;
  }

  .Attendence-table th,
  .Attendence-table td {
    padding: 0.75rem 0.5rem;
  }

  .Attendence-employee-name {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .Attendence-name-avatar {
    width: 2rem;
    height: 2rem;
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .Attendence-page-header {
    padding: 1.5rem 1rem;
  }

  .Attendence-page-title {
    font-size: 1.75rem;
  }

  .Attendence-summary-card {
    padding: 1rem;
  }

  .Attendence-info p {
    font-size: 1.5rem;
  }

  .Attendence-table-container {
    font-size: 0.8rem;
  }
}

/* Print Styles */
@media print {
  .Attendence-page-header,
  .Attendence-controls,
  .Attendence-submit-section {
    display: none;
  }

  .Attendence-container {
    background: white;
    padding: 0;
  }

  .Attendence-table-wrapper {
    box-shadow: none;
    border: 1px solid var(--color-border);
  }
}

/* Focus Styles for Accessibility */
.Attendence-button:focus,
.Attendence-select:focus,
.Attendence-date-input:focus,
.Attendence-status-select:focus {
  outline: 2px solid #6a11cb;
  outline-offset: 2px;
}

/* Smooth Animations */
* {
  transition: all var(--transition-normal);
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Attendance/Attendence.css"],"names":[],"mappings":"AAAA;EACE,iEAAiE;EACjE,kEAAkE;EAClE,kEAAkE;EAClE,mEAAmE;EACnE,qEAAqE;EACrE,uEAAuE;EACvE,qEAAqE;EACrE,oEAAoE;EACpE,kEAAkE;EAClE,0CAA0C;EAC1C,0CAA0C;EAC1C,2CAA2C;EAC3C,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B;kCACgC;EAChC,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,kCAAkC;EAClC,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;UACQ;EACR,yCAAyC;AAC3C;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,yCAAyC;EACzC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yCAAyC;EACzC,mCAAmC;EACnC,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,cAAc;EACd,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mCAAmC;EACnC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,qCAAqC;EACrC,sCAAsC;EACtC,eAAe;EACf,gCAAgC;EAChC,mCAAmC;EACnC,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yDAAmP;EACnP,yCAAyC;EACzC,4BAA4B;EAC5B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,oCAAoC;EACpC,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;EACzC,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,qBAAqB;EACrB,sCAAsC;EACtC,qBAAqB;EACrB,gBAAgB;EAChB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,mCAAmC;EACnC,YAAY;EACZ,oBAAoB;EACpB,sCAAsC;EACtC,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,kBAAkB;AAClB;EACE;;;iCAG+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,8CAA8C;EAC9C,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;EACpC,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,sCAAsC;EACtC,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,yBAAyB;EACzB,mCAAmC;EACnC,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE;;2CAEyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,sCAAsC;EACtC,qCAAqC;EACrC,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,yBAAyB;EACzB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,qCAAqC;EACrC,sCAAsC;EACtC,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,iBAAiB;AACjB;EACE;;;IAGE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,qCAAqC;EACvC;AACF;;AAEA,mCAAmC;AACnC;;;;EAIE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,wCAAwC;AAC1C","sourcesContent":[":root {\n  --hot-gradient: linear-gradient(135deg, #ff6b6b 0%, #ff8e8e 100%);\n  --warm-gradient: linear-gradient(135deg, #ffd166 0%, #ffe066 100%);\n  --cold-gradient: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);\n  --total-gradient: linear-gradient(135deg, #8e2de2 0%, #4a00e0 100%);\n  --primary-gradient: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);\n  --secondary-gradient: linear-gradient(135deg, #f857a6 0%, #ff5858 100%);\n  --success-gradient: linear-gradient(135deg, #00b09b 0%, #96c93d 100%);\n  --header-gradient: linear-gradient(135deg, #4776e6 0%, #8e54e9 100%);\n  --card-gradient: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.08);\n  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 8px 30px rgba(0, 0, 0, 0.12);\n  --border-radius-sm: 8px;\n  --border-radius-md: 12px;\n  --border-radius-lg: 20px;\n  --border-radius-xl: 30px;\n  --transition-fast: 0.2s ease;\n  --transition-normal: 0.3s ease;\n  --transition-slow: 0.5s ease;\n  --font-primary: \"Poppins\", \"Inter\", -apple-system, BlinkMacSystemFont,\n    \"Segoe UI\", Roboto, sans-serif;\n  --color-text-primary: #1e293b;\n  --color-text-secondary: #64748b;\n  --color-text-tertiary: #94a3b8;\n  --color-bg-primary: #ffffff;\n  --color-bg-secondary: #f8fafc;\n  --color-bg-tertiary: #f1f5f9;\n  --color-border: #e2e8f0;\n  --color-hot: #ff6b6b;\n  --color-warm: #ffd166;\n  --color-cold: #4facfe;\n  --color-active: #48bb78;\n  --color-pending: #ed8936;\n  --color-inactive: #a0aec0;\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: var(--font-primary);\n  background: var(--color-bg-secondary);\n  color: var(--color-text-primary);\n  line-height: 1.6;\n}\n\n/* Page Header */\n.Attendence-page-header {\n  background: var(--header-gradient);\n  padding: 2rem 1.5rem;\n  text-align: center;\n  color: white;\n  margin-bottom: 2rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.Attendence-page-header::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")\n    repeat;\n  animation: float 20s ease-in-out infinite;\n}\n\n@keyframes float {\n  0%,\n  100% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n.Attendence-page-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin: 0 0 0.5rem 0;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  position: relative;\n  z-index: 1;\n}\n\n.Attendence-page-subtitle {\n  font-size: 1.1rem;\n  opacity: 0.9;\n  font-weight: 400;\n  position: relative;\n  z-index: 1;\n}\n\n/* Main Container */\n.Attendence-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 1.5rem 2rem;\n}\n.Attendence-header-container {\n  background: var(--color-bg-primary);\n  border-radius: var(--border-radius-lg);\n  padding: 1rem;\n  margin-bottom: 2rem;\n  box-shadow: var(--shadow-md);\n  position: relative;\n  overflow: hidden;\n}\n\n.Attendence-header-content {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.Attendence-header {\n  font-size: 2rem;\n  font-weight: 600;\n  color: #000000;\n  margin: 0 0 1rem 0;\n  /* background: var(--primary-gradient); */\n  /* -webkit-background-clip: text; */\n  /* -webkit-text-fill-color: transparent; */\n  /* background-clip: text; */\n}\n\n.Attendence-header-decoration {\n  width: 80px;\n  height: 4px;\n  background: var(--primary-gradient);\n  margin: 0 auto;\n  border-radius: 2px;\n}\n\n/* Controls */\n.Attendence-controls {\n  display: grid;\n  grid-template-columns: 1fr 1fr auto;\n  gap: 1.5rem;\n  align-items: end;\n}\n\n.Attendence-form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.Attendence-label {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin-bottom: 0.5rem;\n  font-size: 0.95rem;\n}\n\n.Attendence-label-icon {\n  margin-right: 0.5rem;\n  font-size: 1.1rem;\n}\n\n.Attendence-select-wrapper {\n  position: relative;\n}\n\n.Attendence-select,\n.Attendence-date-input {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-md);\n  font-size: 1rem;\n  font-family: var(--font-primary);\n  background: var(--color-bg-primary);\n  color: var(--color-text-primary);\n  transition: var(--transition-normal);\n}\n\n.Attendence-select:focus,\n.Attendence-date-input:focus {\n  outline: none;\n  border-color: #6a11cb;\n  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);\n  transform: translateY(-1px);\n}\n\n.Attendence-select {\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n  background-position: right 0.75rem center;\n  background-repeat: no-repeat;\n  background-size: 1rem;\n  padding-right: 2.5rem;\n}\n\n/* Buttons */\n.Attendence-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: var(--border-radius-md);\n  font-size: 1rem;\n  font-weight: 600;\n  font-family: var(--font-primary);\n  cursor: pointer;\n  transition: var(--transition-normal);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  position: relative;\n  overflow: hidden;\n}\n\n.Attendence-button::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.2),\n    transparent\n  );\n  transition: left 0.5s;\n}\n\n.Attendence-button:hover::before {\n  left: 100%;\n}\n\n.Attendence-button-load {\n  background: linear-gradient(135deg, #0d5787 0%, #91c8e4 100%);\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.Attendence-button-load:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.Attendence-button-submit {\n  /* background: var(--success-gradient); */\n  background: linear-gradient(135deg, #0d5787 0%, #69aed2 100%);\n  color: white;\n  font-size: 1.1rem;\n  padding: 1rem 2rem;\n  box-shadow: var(--shadow-sm);\n}\n\n.Attendence-button-submit:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.Attendence-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.Attendence-button-icon {\n  font-size: 1.1rem;\n}\n\n/* Loading States */\n.Attendence-loading {\n  pointer-events: none;\n}\n\n.Attendence-spinner {\n  width: 1rem;\n  height: 1rem;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top: 2px solid white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Error Message */\n.Attendence-error-message {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  background: var(--hot-gradient);\n  color: white;\n  padding: 1rem 1.25rem;\n  border-radius: var(--border-radius-md);\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n  box-shadow: var(--shadow-sm);\n  animation: slideIn 0.3s ease;\n}\n\n.Attendence-error-icon {\n  font-size: 1.2rem;\n}\n\n.Attendence-error-text {\n  flex: 1;\n}\n\n.Attendence-error-close {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 1.5rem;\n  cursor: pointer;\n  opacity: 0.8;\n  transition: opacity var(--transition-fast);\n}\n\n.Attendence-error-close:hover {\n  opacity: 1;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Success Message */\n.Attendence-success-message {\n  position: fixed;\n  top: 2rem;\n  right: 2rem;\n  background: var(--success-gradient);\n  color: white;\n  padding: 1rem 1.5rem;\n  border-radius: var(--border-radius-md);\n  font-weight: 600;\n  box-shadow: var(--shadow-lg);\n  z-index: 1000;\n  animation: slideInRight 0.3s ease;\n}\n\n@keyframes slideInRight {\n  from {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* Table Wrapper */\n.Attendence-table-wrapper {\n  /* background: var(--color-bg-primary);\n  border-radius: var(--border-radius-lg);\n  padding: 2rem;\n  box-shadow: var(--shadow-md); */\n  animation: fadeInUp 0.5s ease;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Summary Cards */\n.Attendence-summary {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.Attendence-summary-card {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  border-radius: var(--border-radius-lg);\n  color: white;\n  font-weight: 600;\n  overflow: hidden;\n  transition: transform var(--transition-normal);\n  box-shadow: var(--shadow-sm);\n  width: 250px;\n}\n\n.Attendence-summary-card:hover {\n  transform: translateY(-5px);\n  box-shadow: var(--shadow-md);\n}\n\n.Attendence-summary-card.Attendence-present {\n  background: var(--success-gradient);\n}\n\n.Attendence-summary-card.Attendence-absent {\n  background: var(--hot-gradient);\n}\n\n.Attendence-summary-card.Attendence-half-day {\n  background: var(--warm-gradient);\n}\n\n.Attendence-icon {\n  font-size: 2rem;\n  opacity: 0.9;\n}\n\n.Attendence-info {\n  flex: 1;\n}\n\n.Attendence-info h4 {\n  margin: 0 0 0.25rem 0;\n  font-size: 0.9rem;\n  opacity: 0.9;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.Attendence-info p {\n  margin: 0;\n  font-size: 2rem;\n  font-weight: 700;\n}\n\n.Attendence-card-percentage {\n  font-size: 0.9rem;\n  font-weight: 600;\n  background: rgba(255, 255, 255, 0.2);\n  padding: 0.25rem 0.5rem;\n  border-radius: var(--border-radius-sm);\n}\n\n.Attendence-card-bg {\n  position: absolute;\n  top: -50%;\n  right: -20px;\n  width: 100px;\n  height: 100px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n/* Table Container */\n.Attendence-table-container {\n  overflow-x: auto;\n  border-radius: var(--border-radius-md);\n  box-shadow: var(--shadow-sm);\n  margin-bottom: 2rem;\n}\n\n/* Table */\n.Attendence-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: var(--color-bg-primary);\n  border-radius: var(--border-radius-md);\n  overflow: hidden;\n}\n\n.Attendence-table thead {\n  /* background: var(--header-gradient); */\n  color: #000000;\n  background: #f3f4f6;\n}\n\n.Attendence-table th {\n  padding: 1.25rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-size: 0.85rem;\n}\n\n.Attendence-table td {\n  padding: 1rem;\n  border-bottom: 1px solid var(--color-border);\n  vertical-align: middle;\n}\n\n.Attendence-table-row:hover {\n  /* background: var(--color-bg-secondary);\n  transform: scale(1.01);\n  transition: all var(--transition-fast); */\n}\n\n.Attendence-row-even {\n  /* background: var(--color-bg-tertiary); */\n}\n\n/* Employee Details */\n.Attendence-employee-id {\n  font-weight: 600;\n  color: var(--color-text-secondary);\n}\n\n.Attendence-employee-code {\n  background: var(--card-gradient);\n  padding: 0.25rem 0.5rem;\n  border-radius: var(--border-radius-sm);\n  font-family: \"Courier New\", monospace;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  font-size: 0.9rem;\n}\n\n.Attendence-employee-name {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.Attendence-name-avatar {\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 50%;\n  background: var(--primary-gradient);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 1rem;\n}\n\n.Attendence-name-text {\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.Attendence-phone-number {\n  font-family: \"Courier New\", monospace;\n  color: var(--color-text-secondary);\n}\n\n.Attendence-designation-badge {\n  /* background: var(--cold-gradient); */\n  color: rgb(0, 0, 0);\n  padding: 0.375rem 0.75rem;\n  border-radius: var(--border-radius-xl);\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n/* Status Elements */\n.Attendence-status-wrapper {\n  min-width: 140px;\n}\n\n.Attendence-status-select {\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-sm);\n  font-size: 0.9rem;\n  font-family: var(--font-primary);\n  cursor: pointer;\n  transition: var(--transition-normal);\n  background: var(--color-bg-primary);\n}\n\n.Attendence-status-select:focus {\n  outline: none;\n  border-color: #6a11cb;\n  box-shadow: 0 0 0 3px rgba(106, 17, 203, 0.1);\n}\n\n.Attendence-status-badge {\n  padding: 0.375rem 0.75rem;\n  border-radius: var(--border-radius-xl);\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.Attendence-status-badge.Attendence-status-present {\n  background: var(--success-gradient);\n  color: white;\n}\n\n.Attendence-status-badge.Attendence-status-absent {\n  background: var(--hot-gradient);\n  color: white;\n}\n\n.Attendence-status-badge.Attendence-status-half-day {\n  background: var(--warm-gradient);\n  color: white;\n}\n\n/* Submit Section */\n.Attendence-submit-section {\n  text-align: center;\n  padding-top: 1.5rem;\n  border-top: 1px solid var(--color-border);\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .Attendence-controls {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .Attendence-summary {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .Attendence-container {\n    padding: 0 1rem 2rem;\n  }\n\n  .Attendence-page-title {\n    font-size: 2rem;\n  }\n\n  .Attendence-header-container,\n  .Attendence-table-wrapper {\n    padding: 1.5rem;\n  }\n\n  .Attendence-table {\n    font-size: 0.9rem;\n  }\n\n  .Attendence-table th,\n  .Attendence-table td {\n    padding: 0.75rem 0.5rem;\n  }\n\n  .Attendence-employee-name {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .Attendence-name-avatar {\n    width: 2rem;\n    height: 2rem;\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .Attendence-page-header {\n    padding: 1.5rem 1rem;\n  }\n\n  .Attendence-page-title {\n    font-size: 1.75rem;\n  }\n\n  .Attendence-summary-card {\n    padding: 1rem;\n  }\n\n  .Attendence-info p {\n    font-size: 1.5rem;\n  }\n\n  .Attendence-table-container {\n    font-size: 0.8rem;\n  }\n}\n\n/* Print Styles */\n@media print {\n  .Attendence-page-header,\n  .Attendence-controls,\n  .Attendence-submit-section {\n    display: none;\n  }\n\n  .Attendence-container {\n    background: white;\n    padding: 0;\n  }\n\n  .Attendence-table-wrapper {\n    box-shadow: none;\n    border: 1px solid var(--color-border);\n  }\n}\n\n/* Focus Styles for Accessibility */\n.Attendence-button:focus,\n.Attendence-select:focus,\n.Attendence-date-input:focus,\n.Attendence-status-select:focus {\n  outline: 2px solid #6a11cb;\n  outline-offset: 2px;\n}\n\n/* Smooth Animations */\n* {\n  transition: all var(--transition-normal);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
